<app-navbar *ngIf="!(location == '/coming-soon' || location?.includes('/courses/view'))"></app-navbar>
<router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/coming-soon' || location?.includes('/courses/view'))"></app-footer>
<ngx-scrolltop></ngx-scrolltop>